<div
  *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.Strain"
  class="product-column-general product-strain"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'">
  {{ rowVm | sectionRowViewModelBasicMethod: 'getStrain' }}
</div>
